// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';

/// <code-import> Place custom imports between <code-import> tags
import { User, UserType } from '..';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UserUserType extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  user: User;
  userType: UserType;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  effectiveDate?: Date;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  userId!: number;
  userTypeId!: number;
}

